import { gql } from '@apollo/client';
const GET_SPECIFICATION_COSTS = gql `
  query GetSpecificationCosts($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        colors(isActive: true) {
          edges {
            node {
              id
              name
            }
          }
        }
        sizes(isActive: true) {
          edges {
            node {
              id
              isActive
              sizeName {
                id
                name
              }
            }
          }
        }
        variants {
          edges {
            node {
              id
              quantity
              estimatedCost
              color {
                id
              }
              size {
                id
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_COSTS;
